module.exports = __webpack_public_path__ + "static/img/banner.7a03492.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/banner.png
// module id = xjkC
// module chunks = 1